import React from "react";

// Components
import Chip from "@material-ui/core/Chip";

// Helpers
import upperfirst from "lodash.upperfirst";

// Styles
import clsx from "clsx";
import {
  createStyles,
  withStyles,
  Theme,
  fade,
  darken,
} from "@material-ui/core/styles";

// Types
import { StandardProps } from "@material-ui/core";

const styles = (theme: Theme) =>
  createStyles({
    /** Styles applied to the list */
    root: {
      display: "flex",
      flexWrap: "wrap",

      // Add spacing between each tag
      "& > *": {
        marginRight: theme.spacing(0.5),
      },

      // Override the "ul" default styles
      listStyle: "none",
      margin: 0,
    },
    /** Styles applied to each tag */
    tag: {
      border: "none",
    },
    /** Styles applied to the "engineering" tag */
    engineering: {
      backgroundColor: fade("#F97316", 0.2),
      color: darken("#F97316", 0.1),
    },
    /** Styles applied to the "product" tag */
    product: {
      backgroundColor: fade("#1565c0", 0.2),
      color: "#1565c0",
    },
    /** Styles applied to the "management" tag */
    management: {
      backgroundColor: fade("#5e35b1", 0.2),
      color: "#5e35b1",
    },
  });

export type TagListClassKey =
  | "root"
  | "tag"
  | "engineering"
  | "product"
  | "management";

export type TagListProps = StandardProps<
  {
    /** Tags to display*/
    readonly tags: string[];
  } & React.HTMLProps<HTMLUListElement>,
  TagListClassKey
>;

const TagList = withStyles(styles)(function TagList({
  tags,
  classes,
  className,
  ...listProps
}: TagListProps): JSX.Element {
  return (
    <ul className={clsx(classes?.root, className)} {...listProps}>
      {tags.map((t) => (
        <Chip
          key={t}
          className={clsx(
            classes?.tag,
            classes ? classes[t as TagListClassKey] : null
          )}
          component="li"
          variant="outlined"
          size="small"
          label={upperfirst(t)}
        />
      ))}
    </ul>
  );
});

export default TagList;
